import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks';
import type { MouseEvent } from 'react';
import { forwardRef, useCallback, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';

import { FrontMenuPopupWrapperItem } from '../helpers/styled';
import type { ISidebarNav } from '../helpers/types';
import { useIsSidebarActive } from '../hooks/useIsSidebarActive';
import { CollapsedSubMenu } from './CollapsedSubMenu';

export interface IFrontMenuChildCollapsed {
  openPopover: (event: MouseEvent<HTMLDivElement>) => void;
  closePopover: () => void;
}

export const FrontMenuChildCollapsed = forwardRef(({ item }: { item: ISidebarNav }, ref) => {
  const navigate = useNavigate();
  const { isChildActive } = useIsSidebarActive();
  const popupState = usePopupState({
    variant: 'popover',
    popupId: `frontMenuItem-${item.key}`,
  });

  useImperativeHandle(ref, () => ({
    openPopover: (event: MouseEvent<HTMLDivElement>) => {
      popupState.open(event);
    },
  }));

  const handleClick = useCallback(
    (link: string) => {
      popupState.close();
      navigate(link);
    },
    [navigate, popupState],
  );

  return (
    <CollapsedSubMenu
      {...bindPopover(popupState)}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {item.children?.map((child, key) => (
        <FrontMenuPopupWrapperItem
          $isActive={isChildActive(child)}
          onClick={() => handleClick(child.link || '')}
          key={key}
        >
          {child.title}
        </FrontMenuPopupWrapperItem>
      ))}
    </CollapsedSubMenu>
  );
});
